import React, { ReactNode } from "react";
import FieldHeader from "./FieldHeader";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FormCheckType } from "react-bootstrap/esm/FormCheck";

interface IProps {
    check: boolean;
    name: string;
    description: string;
    className?: string;
    handleClick?: any;
    selectedWarning?: ReactNode;
    type?: FormCheckType;
}

const CustomRadio = (props: IProps) => {
    return (
        <>
            <div
                className={`custom-switch-main-wrapper radio ${props.check ? "selectInput" : ""} ${props.className ? props.className : ""}`}
                onClick={props.handleClick}
            >
                <div className="custom-toggle-switch-wrapper">
                    <Form.Check type={props.type || "radio"} onChange={(e) => {}} checked={props.check} />
                </div>
                <FieldHeader name={props.name} description={props.description} />
            </div>
            {props.selectedWarning && props.check && (
                <div className="custom-switch-main-wrapper warning">
                    <FontAwesomeIcon icon={faWarning} />
                    <div>{props.selectedWarning}</div>
                </div>
            )}
        </>
    );
};

export default CustomRadio;
